var _rect, _rect2, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontalGraphInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_156_3068)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#pattern0)",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1652 34.275C30.2102 34.275 25.2396 34.275 20.2845 34.275C19.2406 34.275 19.1782 34.1814 19.1938 32.06C19.225 26.5381 18.851 27.3493 21.5311 27.3493C31.0048 27.3181 40.4942 27.3493 49.968 27.3493C51.1678 27.3493 51.1833 27.3805 51.1833 29.8138C51.1833 30.6562 51.1522 31.4673 51.1833 32.3096C51.2457 33.7759 50.9496 34.3374 50.2017 34.3062C45.1843 34.275 40.167 34.275 35.1652 34.275Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1652 45.6578C30.2102 45.6578 25.2396 45.6578 20.2845 45.6578C19.2406 45.6578 19.1782 45.559 19.1938 43.3211C19.225 37.4958 18.851 38.3515 21.5311 38.3515C31.0048 38.3185 40.4942 38.3515 49.968 38.3515C51.1678 38.3515 51.1833 38.3844 51.1833 40.9515C51.1833 41.8401 51.1522 42.6957 51.1833 43.5843C51.2457 45.1312 50.9496 45.7236 50.2017 45.6907C45.1843 45.6578 40.167 45.6578 35.1652 45.6578Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_156_3068",
    transform: "translate(0 -0.207407) scale(0.000925926)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_3068",
    x1: 39.9333,
    y1: 83.2,
    x2: 15.8,
    y2: -32.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFECE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F9F8",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalGraphInCircle);
export default __webpack_public_path__ + "static/media/horizontalGraphInCircle.85e933ca4b7339a03bc03873ca6dbd21.svg";
export { ForwardRef as ReactComponent };